import { render } from "./Attorney.vue?vue&type=template&id=2aaa6eff"
import script from "./Attorney.vue?vue&type=script&lang=js"
export * from "./Attorney.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__